import { AnchorLink } from '@kit/ui'
import { createLink } from '@tanstack/react-router'

export const Link = createLink(AnchorLink)
export interface LinkProps extends React.ComponentProps<typeof Link> {}
